<script>
import StoreSearchResultsTabMap from '@phoenix/mixins/components/store/StoreSearchResultsTabMap';
import { PhxStoreLocator } from '@phx-styleguides/als';
import { mapState } from 'vuex';
import Store from '@phoenix/components/Store';
import { CONSENT_NAMES, useConsent } from '@phoenix/composables/consent';

export default {
  components: {
    PhxStoreLocator,
  },

  mixins: [StoreSearchResultsTabMap],

  emits: ['geolocation'],

  setup() {
    const { isConsentAccepted, acceptConsent } = useConsent();

    return {
      consentAccepted: isConsentAccepted(CONSENT_NAMES.gmaps),
      onConsentAccept: () => acceptConsent(CONSENT_NAMES.gmaps),
    };
  },

  computed: {
    ...mapState('storeSearch', ['isLoading']),

    noResultsText() {
      return this.$t(this.isLoading ? 'StoreSearch.suggestions.loading' : 'StoreSearch.suggestions.noResults');
    },

    consentI18n() {
      return {
        giveConsentLabel: this.$t('StoreLocator.consentButton.label'),
        privacyPolicyLabel: this.$t('StoreLocator.privacyPolicyButton.label'),
      };
    },

    privacyPolicyUrl() {
      return window.route('privacy_policy');
    },

    getStores() {
      const stores = this.stores.length ? this.stores : this.allStores;

      return stores.map((store) => {
        if (!store.isReseller) {
          const status = new Store(
            store.openingHours,
            store.specialDays,
            store.timezone,
            store.isOnline,
            store.id,
            store.isComingSoon,
          ).getStatusLabel();

          const boutiqueTypeTag = this.$t('Store.boutique');

          return { ...store, status, boutiqueTypeTag };
        }

        return store;
      });
    },
  },

  methods: {
    onGeolocation() {
      this.$emit('geolocation');
    },
  },
};
</script>

<template>
  <phx-store-locator
    :id="id"
    ref="storeLocator"
    :api-key="apiKey"
    :map-id="mapId"
    :engine="engine"
    :center="center"
    :zoom="zoom"
    :geolocation="position"
    :fit-bounds="fitBounds"
    :locations="getStores"
    :region="region"
    :panel-title="$t('StoreSearch.title')"
    :close-button-label="$t('Button.close')"
    :open-panel-button-label="$t('StoreSearch.storesList')"
    :get-direction-link-label="$t('Store.getDirections')"
    :see-all-boutiques-link-label="$t('StoreSearch.seeAllStores')"
    :see-all-boutiques-link-url="allStoresUrl"
    :no-result-text="noResultsText"
    :consent-accepted="consentAccepted"
    :consent-text="$t('StoreLocator.consentText')"
    :i18n="consentI18n"
    :privacy-policy-url="privacyPolicyUrl"
    @geolocation:enable="onGeolocation"
    @map:initialized="onMapInitialized"
    @map:bounds:changed="onMapBoundsChanged"
    @consent:accept="onConsentAccept"
  />
</template>
